import React from 'react';
import './WalletWelcome.css';

const WalletWelcome = ({ onConnect, onCancel }) => {
  return (
    <div className="wallet-welcome-overlay" onClick={onCancel}>
      <div className="wallet-welcome-modal" onClick={(e) => e.stopPropagation()}>
        <div className="wallet-welcome-header">
          <div className="wallet-welcome-logo">🥋</div>
          <h2 className="wallet-welcome-title">Welcome to Outbox BJJ</h2>
          <p className="wallet-welcome-subtitle">Connect your wallet to access your profile</p>
        </div>

        <div className="wallet-welcome-body">
          <div className="wallet-welcome-feature">
            <span className="wallet-welcome-icon">👤</span>
            <div>
              <h3>Personal Profile</h3>
              <p>Track your progress and achievements</p>
            </div>
          </div>

          <div className="wallet-welcome-feature">
            <span className="wallet-welcome-icon">⭐</span>
            <div>
              <h3>MA+ Tokens</h3>
              <p>Earn rewards for attendance and participation</p>
            </div>
          </div>

          <div className="wallet-welcome-feature">
            <span className="wallet-welcome-icon">📊</span>
            <div>
              <h3>Attendance History</h3>
              <p>View your training schedule and stats</p>
            </div>
          </div>

          <div className="wallet-welcome-feature">
            <span className="wallet-welcome-icon">🏆</span>
            <div>
              <h3>Belt Progress</h3>
              <p>Monitor your journey to the next level</p>
            </div>
          </div>
        </div>

        <div className="wallet-welcome-footer">
          <button className="wallet-welcome-btn wallet-welcome-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button className="wallet-welcome-btn wallet-welcome-btn-primary" onClick={onConnect}>
            <span className="wallet-welcome-metamask-icon">🦊</span>
            Connect MetaMask
          </button>
        </div>
      </div>
    </div>
  );
};

export default WalletWelcome;
